"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoleForemanWirePhaseHeightFieldJoin = void 0;
const field_join_ikecalc_1 = require("./field.join.ikecalc");
const WIRE_PHASE_HEIGHTS = ['phaseAHeight', 'phaseBHeight', 'phaseCHeight'];
class PoleForemanWirePhaseHeightFieldJoin extends field_join_ikecalc_1.IkeCalcFieldJoin {
    static accepts(field) {
        return WIRE_PHASE_HEIGHTS.indexOf(field.schema.id) > -1;
    }
    constructor(field) {
        super(field);
        this.type = 'PoleForemanWirePhaseHeightJoin';
    }
    joins(other) {
        const joinableHeight = this.getFieldValue(this.wire, this.field.schema.id);
        if (joinableHeight != null) {
            return false;
        }
        const framingType = this.getFieldValue(this.wire, 'framingType');
        if (this.isDeadend(framingType)) {
            return false;
        }
        if (!other.wire.hasField(this.field.schema.id) || this.getFieldValue(other.wire, this.field.schema.id) != null) {
            return false;
        }
        return (this.spansOpposing(this.span, other.span) &&
            this.fieldsEqual(this.wire, other.wire, 'framingType') &&
            this.fieldsEqual(this.wire, other.wire, 'wireSize') &&
            this.fieldsEqual(this.wire, other.wire, 'wireQuantity'));
    }
}
exports.PoleForemanWirePhaseHeightFieldJoin = PoleForemanWirePhaseHeightFieldJoin;
//# sourceMappingURL=field.join.poleforeman.wire.js.map